//CarbonPieChart.vue



<template>

	<!-- <div id="chart-container" style="max-width: 200px"> -->
	<div id="chart-container">
		<vue3-chart-js v-bind="{ ...doughnutChart }" id="chart1"/>
	</div> 

	<!-- <canvas id="chart-container">
		<vue3-chart-js v-bind="{ ...doughnutChart }" id="chart1"/>
	</canvas> -->

</template>



<script>

import Vue3ChartJs from '@j-t-mcc/vue3-chartjs';
import { useStore } from 'vuex';
import { computed, ref } from 'vue';


// var slabs = this.carbonData.slabs;

export default {

components: {
	Vue3ChartJs,
},
props: {
	carbonData: Object
},
setup(props) {

	//Make gradient colors
	//---------------------------------------------------------
	const store = useStore();
	const ctx = store.state.ctx;

	//Gradient Blue
	var gradientBlue = ctx.createLinearGradient(0, 0, 0, 150);
	gradientBlue.addColorStop(0, '#1563bd');
	gradientBlue.addColorStop(1, '#84d1e8');

	//Gradient Green
	var gradientGreen = ctx.createLinearGradient(0, 0, 0, 150);
	gradientGreen.addColorStop(0, '#537a37');
	gradientGreen.addColorStop(1, '#95bf77');

	//Gradient Red
	var gradientRed = ctx.createLinearGradient(0, 0, 0, 150);
	gradientRed.addColorStop(0, '#ff3636');
	gradientRed.addColorStop(1, '#ff7575');

	//Gradient Orange
	var gradientOrange = ctx.createLinearGradient(0, 0, 0, 150);
	gradientOrange.addColorStop(0, '#ed8e3b');
	gradientOrange.addColorStop(1, '#f5ae71');

	//Doughnut Chart
	//---------------------------------------------------------
	const doughnutChart = {
		type: "doughnut",
		data: {
			labels: ['Slabs', 'Columns', 'Foundation', 'Core'],
			datasets: [
				{
					// backgroundColor: ['rgba(143, 188, 143, 1)', 'rgba(135, 206, 250, 1)', 'rgba(205, 133, 63, 1)', 'rgba(230, 78, 62, 1)'],
					backgroundColor: [gradientGreen, gradientBlue, gradientOrange, gradientRed],
					// data: [10, 20, 40, 8],
					data: [ props.carbonData.slabs, props.carbonData.columns, props.carbonData.foundation, props.carbonData.core ],
					// borderRadius: 20,
					borderWidth: 0,
					cutoutPercentage: 70,
				},
			],
		},
		options: {
			cutout: '80%',
			radius: '40%',
			plugins: {
				responsive: true,
				maintainAspectRatio: false,
				legend: {
					position: 'right',
				}
			},
			elements: {
				arc: {
					spacing: 10,
					borderRadius: 15
				}
			}
		}
	};
	const getData =  () => {
		const data = this.carbonData;
		console.log('getData');
		console.log(data);
		doughnutChart.data.labels = data.labels;
		doughnutChart.data.datasets = data.datasets;
	//   doughnutChart.value.update();
    };
	return {
		doughnutChart,
		getData
	};
},
};
</script>


<style scoped>

#chart-container {
	position: fixed;
	/* border: 1px solid green; */
	padding: 25px;
	height: 600px;
}

#chart1 {
	margin-top: 50px;
	margin-left: 50px;
	height: 60px;
	/* border: 1px solid red; */
}


</style>